// extracted by mini-css-extract-plugin
module.exports = {"overlay":"SupplierModal_overlay__2mmzo","inputContainer":"SupplierModal_inputContainer__WOZYX","feedback":"SupplierModal_feedback__2ONCa","text":"SupplierModal_text__GO4ut"};